<template>
    <b-container fluid>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <div >
        <filtros-busqueda :empleados.sync="empleados" @buscar="buscarDatosResumen" :tipo-busqueda="tipoBusqueda" :mostrarFiltroTodos="false"/>
        <b-button @click="exportarExcel()" :disabled="!excel" variant="info">Exportar Excel</b-button>
      </div>
    <div class="container" style="background-color:white">
        <div>
            <h1 id="h1">Pago de bloque especialistas</h1>
        </div>
        <div class="row" style="height:auto; width:1140px;">

          <b-table-simple hover small caption-top responsive fixed>
            <b-thead head-variant="blue">
              <b-tr>
                <b-th colspan="1">ID especialista</b-th>
                <b-th colspan="1">Nombre especialista</b-th>
                <b-th colspan="1">Especialidad</b-th>
                <b-th colspan="1">Quincena</b-th>
                <b-th colspan="1">Fecha de inicio</b-th>
                <b-th colspan="1">Fecha de fin</b-th>
                <b-th colspan="1">Fecha de pago</b-th>
              </b-tr>
              <b-tr>
                <b-th>{{idEmpleado}}</b-th>
                <b-th>{{nombreEspecialista}}</b-th>
                <b-th>{{especialidad}}</b-th>
                <b-th v-if="datos.quincena!=null">{{datos.quincena==1?"Primera":"Segunda"}}</b-th>
                <b-th>{{datos.fechaInicio | formatoFechaCorta}}</b-th>
                <b-th>{{datos.fechaFin | formatoFechaCorta}}</b-th>
                <b-th>{{fechaDePago | formatoFechaCorta}}</b-th>
              </b-tr>
            </b-thead>
          </b-table-simple>

        </div>
    </div>
      <div>
        <b-alert  variant="success"
                  show
        >
          <span style="margin-right: 30%;">Compensación generada en el periodo </span>
          <span style="margin-right: 10%;" >Total a recibir: {{totalPagoArecibir | moneda}} </span>
        </b-alert>

      </div>

      <div>
        <b-spinner v-if="loader" variant="primary" ></b-spinner>
        <b-card v-else no-body class="overflow-hidden">
          <br/>
          <b-row no-gutters v-if="nombreEspecialista !== null">

              <b-col cols="2">
                <b-card-title style="font-size: 12px;"><b>Pago garantizado</b></b-card-title>
                <b-list-group >
                  <b-list-group-item> {{ montoPagoGarantizado | moneda }} </b-list-group-item>
                </b-list-group>
              </b-col>

            <b-col cols="6">
              <b-card-title style="font-size: 12px;"><b>Pago por productividad</b></b-card-title>
              <b-list-group >
                <b-list-group-item > {{bonoProductividad | moneda }} </b-list-group-item>
              </b-list-group>
            </b-col>

            <b-col cols="2" v-if="$localStorageService.can('Detalle_recibo_bloque_desemp')" >
              <b-card-title style="font-size: 12px;" v-if=" datos.quincena !== null "><b>Bono de desempeño {{ datos.quincena==1?"1ra":"2da"}} Quincena</b></b-card-title>
              <b-list-group >
                <b-list-group-item>
                    <span >{{bonoDesempenio | moneda }}</span>
                </b-list-group-item>
              </b-list-group>
            </b-col>

            <b-col cols="2" v-if="aplicaBonoExtraordinario && $localStorageService.can('Detalle_recibo_bloque_extra')" >
              <b-card-title style="font-size: 12px;" v-if=" datos.quincena !== null ">
                <b>Bono extraordinario {{ datos.quincena==1?"1ra":"2da"}} Quincena</b>
              </b-card-title>
              <b-list-group >
                <b-list-group-item>
                    <span >{{bonoExtraordinario | moneda }}</span>
                </b-list-group-item>
              </b-list-group>
            </b-col>

          </b-row>
          <br/>
          <b-row no-gutters v-if="nombreEspecialista !== null && $localStorageService.can('Detalle_recibo_bloque')">

            <b-col cols="2">
              <b-list-group style="height: auto;">
                <b-list-group-item class="tamaño"> <b> {{ numeroBloques }} </b> Bloques trabajados en el periodo </b-list-group-item>
              </b-list-group>
            </b-col>
            <b-col cols="6" >
              <b-row no-gutters>
                <b-col>
                  <b-row no-gutters>
                    <b-col cols="12">
                      <b-list-group >
                        <b-list-group-item  class="tamaño">
                          <b v-if="comisionBloque">{{comisionBloque.monto | moneda}}</b>
                          <b v-else>$0</b>
                        </b-list-group-item>
                      </b-list-group>
                    </b-col>
                    <b-col cols="12">
                      <b-list-group >
                        <b-list-group-item class="tamaño">
                          <b v-if="comisionBloque"> {{comisionBloque.totalComisiones}}</b>
                          <b v-else> 0 </b>
                          Tx bloque
                        </b-list-group-item>
                      </b-list-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row no-gutters>
                    <b-col cols="12">
                      <b-list-group >
                        <b-list-group-item  class="tamaño">
                          <b v-if="comisionEmergencia">{{comisionEmergencia.monto | moneda}}</b>
                          <b v-else>$0</b>
                        </b-list-group-item>
                      </b-list-group>
                    </b-col>
                    <b-col cols="12">
                      <b-list-group >
                        <b-list-group-item class="tamaño">
                          <b v-if="comisionEmergencia"> {{comisionEmergencia.totalComisiones}}</b>
                          <b v-else> 0 </b>
                          Tx emergencia
                        </b-list-group-item>
                      </b-list-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row no-gutters>
                    <b-col cols="12">
                      <b-list-group >
                        <b-list-group-item class="tamaño"> <b> {{comisionBanda | moneda}}</b></b-list-group-item>
                      </b-list-group>
                    </b-col>
                    <b-col cols="12">
                      <b-list-group >
                        <b-list-group-item class="tamaño"> <b> {{totalTratRealizadosBanda}}</b> Tx multiplicadora </b-list-group-item>
                      </b-list-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="2" >
              <b-list-group >
                <b-list-group-item>
                  <span class="tamaño"> <b> {{ prodMaximaBonoDesempenio }}</b> Productividad máxima para bono de desempeño</span>
                </b-list-group-item>
              </b-list-group>
            </b-col>

            <b-col cols="2" >
              <b-list-group >
                <b-list-group-item>
                  <span class="tamaño" > <b> {{ numeroBloques }}</b> Bloques trabajados en el periodo</span>
                </b-list-group-item>
              </b-list-group>
            </b-col>

            <b-col  >
            </b-col>

          </b-row>
        </b-card>
        <br/>
        <br/>
      </div>


  </b-container>
</template>
<script>
import FiltrosBusqueda from "@/components/Compensaciones/FiltrosBusqueda";
import XLSX from 'xlsx';
export default{
  components: {FiltrosBusqueda},
  props: {
        empleados: Array,
        aplicaBonoExtraordinario: Boolean
    },
    data(){
        return{
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
          excel: false,
            loader: false,
            quincena: null,
            datos: {
                fechaInicio: null,
                fechaFin: null,
                quincena: null,
                idClinica: null,
                idEmpleado:null,
            },
          tipoBusqueda: "quincena",
          fechaDePago:null,
            fields: {   },
            especialidad: null,
          idEmpleado: null,
          nombreEspecialista: null,
          totalPagoArecibir: 0,

          totalTratamientosProductividad: 0, // Bono productividad
          bonoProductividad:0.0,             // Bono productividad

          numeroBloques: 0,                 // Pago garantizado
          montoPagoGarantizado:0.0,         // Pago garantizado

          totalTratRealizados: 0,           // Bono desempeño
          bonoDesempenio: 0.0,              // Bono desempeño

          bonoExtraordinario: 0.0,          // Bono Extraordinario

          totalTratRealizadosBanda: 0,           // Bono desempeño
          prodMaximaBonoDesempenio: 0,
          comisionBanda: 0.0,              // Bono desempeño
          filtros: null,
          comisionEmergencia: null,
          comisionBloque: null
        }
    },
    created() {
      this.debug = this.$localStorageService.getDebug();
    },
    methods: {
      limpiarDatos(){
        this.idEmpleado = null;
              this.nombreEspecialista = null;

              this.bonoProductividad = 0.0;
              this.totalTratamientosProductividad = 0;
              this.montoPagoGarantizado = 0.0;
              this.numeroBloques = 0;
              this.totalTratRealizados = 0;
              this.bonoDesempenio = 0.0;
              this.especialidad = null;
              this.bonoExtraordinario = 0.0;
              this.fechaDePago = null;
              this.totalTratRealizadosBanda = 0;
              this.prodMaximaBonoDesempenio = 0;
              this.comisionBanda = 0.0;
              this.comisionEmergencia = null;
              this.comisionBloque = null;
              this.totalPagoArecibir = 0;
              this.excel = false;
      },
      exportarExcel(){
        const fecha = this.$moment(new Date()).format('l')
      const newDate = fecha.split("/")
      var dia = newDate[0];
      var mes = newDate[1];
      var anio = newDate[2];

       

      let datosExcel = [];
          let datos = {
            "ID especialista":this.idEmpleado,
            "Nombre especialista": this.nombreEspecialista,
            "Especialidad": this.especialidad,
            "Quincena": this.datos.quincena==1?"Primera":"Segunda",
            "Fecha de inicio": this.$moment(this.datos.fechaInicio).format('DD/MM/YYYY'),
            "Fecha de fin": this.$moment(this.datos.fechaFin).format('DD/MM/YYYY'),
            "Fecha de pago": this.$moment(this.fechaDePago).format('DD/MM/YYYY'),
            "Total pago a recibir": "$ " + this.totalPagoArecibir,
            "Pago garantizado": "$ " + this.montoPagoGarantizado,
            "Pago productividad": "$ " + this.bonoProductividad,
            "Bono desempeño en la quincena": "$ " + this.bonoDesempenio,
            "Bono extraordinario en la quincena": "$ " + this.bonoExtraordinario,
            "Bloques trabajados en el periodo": this.numeroBloques,
            "Productividad máxima para bono de desempeño": this.prodMaximaBonoDesempenio,

        }
        datosExcel.push(datos);

       let data = XLSX.utils.json_to_sheet(datosExcel)
      const workbook = XLSX.utils.book_new()
      const filename = 'recibo_bloque_'+dia+'_'+mes+'_'+anio;
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)

      },
        buscarDatosResumen(filtro) {
          this.limpiarDatos();
          
          this.filtros = filtro
        this.loader = true
          this.datos=filtro;
        this.vaciarDatos();

        this.$http.post(this.$api + 'comisiones/comision_bloque/empleado', filtro).then(respuesta => {
            if (respuesta.data.data) {
              let d = respuesta.data.data;
              this.idEmpleado = d.idEmpleado
              this.nombreEspecialista = d.nombreEspecialista

              this.bonoProductividad = d.bonoProductividad;
              this.totalTratamientosProductividad = d.totalTratamientosProductividad;
              this.montoPagoGarantizado = d.pagoGarantizado;
              this.numeroBloques = d.bloquesTrabajados;
              this.totalTratRealizados = d.totalTratRealizados;
              this.bonoDesempenio = d.bonoDesempenio;
              this.especialidad = d.especialidad;
              this.bonoExtraordinario = d.bonoExtraordinario;
              this.fechaDePago = d.fechaPago
              this.totalTratRealizadosBanda = d.totalTratRealizadosBanda;
              this.prodMaximaBonoDesempenio = d.prodMaximaBonoDesempenio;
              this.comisionBanda = d.comisionBanda;
              this.comisionBloque = d.comisionBloque;
              this.comisionEmergencia = d.comisionEmergencia;
              this.totalPagoArecibir = d.totalARecibir;
              this.excel = true;
            }
        }).finally(() => {
              this.loader = false;
            })
        },
      vaciarDatos(){
        this.bonoProductividad = 0.0
        this.totalTratamientosProductividad = 0.0
        this.montoPagoGarantizado = 0.0
        this.numeroBloques = 0.0
        this.totalTratRealizados = 0.0
        this.bonoDesempenio = 0.0
        this.especialidad = 0.0
        this.bonoExtraordinario = 0.0
        this.totalPagoArecibir = 0.0
        this.fechaDePago = null;
      }
    }
}
</script>
<style>
#h1{
    text-align: center;
    font-size: 25px;
    color: rgb(80, 180, 220);
    font-weight: bold;
}
.tamaño{
  font-size: 13px;
}
</style>